/** Accessible required-field indicator for form labels. */
export function RequiredFieldMarker() {
    return (
        <>
            <span className="text-danger" aria-hidden="true">
                *
            </span>
            <span className="visually-hidden"> (required)</span>
        </>
    );
}
